__turbopack_context__.v({
  "hidden": "PrimaryNav-module__8qrukG__hidden",
  "isOpen": "PrimaryNav-module__8qrukG__isOpen",
  "isUserAccountOpen": "PrimaryNav-module__8qrukG__isUserAccountOpen",
  "previewMode": "PrimaryNav-module__8qrukG__previewMode",
  "primaryNav": "PrimaryNav-module__8qrukG__primaryNav",
  "transparent": "PrimaryNav-module__8qrukG__transparent",
});
